import { render, staticRenderFns } from "./Locales.vue?vue&type=template&id=ec839dd0&scoped=true"
import script from "./Locales.vue?vue&type=script&lang=js"
export * from "./Locales.vue?vue&type=script&lang=js"
import style0 from "./Locales.vue?vue&type=style&index=0&id=ec839dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec839dd0",
  null
  
)

export default component.exports